import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="terms">
      <Header />

      <section
        className="aside-navigation-main-content"
        data-test-id="aside-navigation-main-content"
      >
        {/*[*/}
        <div
          className="responsive-content responsive-content-page customer-service terms"
          data-style="content-page"
        >
          <span />
          <div className="desktopContentWrapper">
            <div data-test="ecm-content-desktop-container">
              <div
                className="ecm-content-wrapper"
                data-style="ecm-content-wrapper"
              >
                <div
                  className="cq-ecm-pages general-page terms-rj-us customer-service"
                  data-page-title="Terms "
                >
                  <div id="text123515207" className="text section breadcrumbs">
                    <ul className="breadcrumbs">
                      <li>
                        <Link onClick={toTop} to="/">
                          Home
                        </Link>
                      </li>

                      <li>
                        <h1>Terms &amp; Conditions</h1>
                      </li>
                    </ul>
                  </div>
                  <div id="text67524365" className="text section">
                    <h1>Terms &amp; Conditions</h1>
                    <p>
                      Last Updated: <b>January 24, 2025</b>
                    </p>
                    <p>
                      Welcome to Retteve.store! We are part of "Williams-Sonoma,
                      Inc." which includes Williams Sonoma, Pottery Barn,
                      Pottery Barn Kids, Pottery Barn Teen, West Elm, Retteve,
                      Mark &amp; Graham, and GreenRow.
                    </p>
                    <p>
                      <Link onClick={toTop} name="terms" id="terms" />
                    </p>
                    <p>
                      PLEASE TAKE A FEW MINUTES TO REVIEW THESE TERMS AND
                      CONDITIONS ("TERMS"). THESE TERMS APPLY TO YOUR ACCESS AND
                      USE OF THE Retteve.store WEBSITE, ALL OTHER WEBSITES,
                      MOBILE SITES, SERVICES, APPLICATIONS, PLATFORMS AND OTHER
                      TOOLS WHERE THESE TERMS APPEAR OR ARE OTHERWISE
                      REFERENCED, OR FOR WHICH NO SEPARATE TERMS ARE PROVIDED AS
                      WELL AS TO YOUR VISITS TO OR INTERACTION WITH US IN ANY OF
                      OUR STORES OR ELSEWHERE (COLLECTIVELY, THE "SITE").&nbsp;
                    </p>
                    <p>
                      These Terms contain an arbitration provision. Please
                      review the{" "}
                      <Link onClick={toTop} to="#arbitration">
                        Arbitration
                      </Link>{" "}
                      section for details.
                    </p>
                    <h4>Who We Are</h4>
                    <p>
                      As used in the Terms and on the Site, "Retteve.store,
                      Retteve, Site, We, Us" refers to Williams-Sonoma, Inc.,
                      with headquarters located at 3250 Van Ness Avenue, San
                      Francisco, California 94109, USA. If you have any
                      questions about these Terms, the{" "}
                      <Link onClick={toTop} to="/privacy">
                        Privacy Policy
                      </Link>{" "}
                      or the Site, you may contact us via the Customer Service
                      information provided on the Site.
                    </p>
                    <h4>These Terms and Conditions May Change</h4>
                    <p>
                      We reserve the right to update or modify these Terms at
                      any time, upon notice to you in writing to the last
                      address provided, by email, by posting on the Site or by
                      any other reasonable means in our sole discretion. We also
                      reserve the right, at any time, to modify or update our{" "}
                      <Link onClick={toTop} to="/privacy">
                        Privacy Policy
                      </Link>{" "}
                      in the same manner.
                    </p>
                    <h4>Additional Terms</h4>
                    <p>
                      From time to time, we may present you with additional
                      terms and conditions for specific services, programs or
                      products (“Additional Terms”). In the event those
                      Additional Terms may conflict with or be inconsistent with
                      these Terms, including any arbitration provision or
                      dispute resolution provision, these Terms will control.
                    </p>
                    <h4>Eligibility</h4>
                    <p>
                      You must be at least 13 years old to use the Site or our
                      mobile applications. If you are under the age of majority
                      in your state of residence (a minor) your parent or legal
                      guardian must agree to these Terms and Conditions on your
                      behalf and you may only access and use the Site and our
                      mobile applications with permission from your parent or
                      legal guardian.
                    </p>
                    <h4>Your Account</h4>
                    <p>
                      You may be required to register with Us in order to access
                      certain services or areas of the Site. Our{" "}
                      <Link onClick={toTop} to="/privacy">
                        Privacy Policy
                      </Link>{" "}
                      explains how we protect and use your information. If you
                      create an account, your username and password are for your
                      personal use only and you are responsible for maintaining
                      the confidentiality of your account information (including
                      your password) and for restricting access to your account.
                      You agree to accept responsibility for all activities that
                      occur under your account or password. In addition to all
                      other rights available, We reserve the right, in our sole
                      discretion, to terminate your account, refuse service to
                      you, or cancel orders.
                    </p>
                    <h4>Shipping and Processing and In-Store Pick-Up</h4>
                    <p>
                      Our shipping and processing charges are intended to
                      compensate Us for the cost of processing your order,
                      handling and packing the products you purchase and
                      delivering them to you. We encourage you to also review
                      detailed information about our{" "}
                      <Link onClick={toTop} to="/shipping">
                        shipping and processing fees
                      </Link>
                      .
                    </p>
                    <p>
                      Some of Our stores offer certain in-store pick up options,
                      including paid hold and ship-to-store services. We will
                      hold your order in the store for 30 days. After 30 days,
                      We will return your item to the store floor or warehouse,
                      as applicable. If you paid for your item by credit card,
                      We will credit the amount of your purchase back to the
                      credit card you used for payment. If you paid for your
                      purchase by cash or check, We will, at our option, provide
                      you with a check or a store credit for the amount of your
                      purchase.
                    </p>
                    <h4>
                      <b>Donations</b>
                    </h4>
                    <p>
                      Cash Donations: Cash donations made to a specific charity
                      through our website will be sent to the charity within 30
                      days after the month the donation was made in, as required
                      by California law.
                    </p>
                    <h4>Intellectual Property</h4>
                    <p>
                      The Site, including all of its information and content
                      such as names, logos, photographs, images, text, data,
                      wallpapers, icons, characters, artwork, graphics, page
                      layout, form, music, sound, messages, software and the
                      code used to generate the pages on the Site and any other
                      materials that appear on the Site (collectively, the
                      "Materials"), is the property of Williams-Sonoma, Inc. or
                      that of Our authorized suppliers or licensors, and is
                      protected by intellectual property and other applicable
                      laws in the United States and/or abroad. Our intellectual
                      property is registered in the United States and abroad.
                      Except as otherwise provided on the Site or by law, you
                      may not download, upload, copy, print, display, reuse,
                      reproduce, publish, license, post, distribute, modify,
                      create derivate works from, sell or otherwise exploit or
                      use any Materials from the Site in whole or in part for
                      any public or commercial purpose without specific prior
                      written permission from Williams-Sonoma, Inc. We are the
                      owner and/or authorized user of the Retteve brand as well
                      as any other registered or unregistered trademarks, trade
                      names, logos, designs, titles and product names appearing
                      on the Site, and is the copyright owner or licensee of the
                      Materials on the Site, unless otherwise indicated. You may
                      not use any metatags or any other "hidden text" utilizing
                      any of Our names or trademarks without Our express written
                      consent.
                    </p>
                    <h4>Use of the Site</h4>
                    <p>
                      We grant you a personal, limited, non-exclusive,
                      nontransferable license to access and make personal use of
                      the Site and the Materials and other information contained
                      on the Site. This license does not include, and we
                      expressly prohibit, any resale or commercial use of the
                      Site; any collection or commercial use of any photographs
                      or other Materials published on the Site; any non-personal
                      use of Our product names, listings, descriptions, or
                      prices; any derivative use of the Site; any downloading,
                      copying, or other use of the Site or the Materials for the
                      benefit of any third party; or any use of data mining,
                      robots, data gathering and extraction tools whether
                      automatic or manual, or other means not purposely made
                      available by us, including to develop or improve any
                      software program, algorithm, or machine learning or
                      artificial intelligence model. We reserve the right to
                      take measures to prevent any such activity. You may use
                      the Site only as permitted by law and these Terms. All
                      rights not expressly granted to you in these Terms are
                      reserved and retained by Us and/or our suppliers and
                      licensors. The licenses granted by Us to you automatically
                      terminate if you do not comply with these Terms.
                    </p>
                    <p>
                      You are responsible for your use of the Site, and for any
                      use of the Site made using your account. Our goal is to
                      create a positive, useful, and safe user experience. To
                      promote this goal, We prohibit certain kinds of conduct
                      that may be harmful to other users or to Us. When you use
                      the Site, you may not:
                    </p>
                    <ul className="bulleted">
                      <li>violate any law or regulation;</li>
                      <li>
                        violate, infringe, or misappropriate our or other
                        people's intellectual property, privacy, publicity, or
                        other legal rights;
                      </li>
                      <li>
                        post or share anything that is illegal, abusive,
                        harassing, harmful to reputation, pornographic,
                        indecent, profane, obscene, hateful, racist, or
                        otherwise objectionable;
                      </li>
                      <li>
                        engage in spidering or harvesting, or participate in the
                        use of software, including spyware, designed to collect
                        data from the Site or mobile applications;
                      </li>
                      <li>
                        transmit any viruses or other computer instructions or
                        technological means whose purpose is to disrupt, damage,
                        or interfere with the use of computers or related
                        systems;
                      </li>
                      <li>
                        use any means to scrape or crawl any pages contained in
                        the Site;
                      </li>
                      <li>
                        attempt to circumvent any technological measure
                        implemented by us or any of our providers or any other
                        third party (including another user) to protect the
                        Site;
                      </li>
                      <li>
                        attempt to decipher, decompile, disassemble, or reverse
                        engineer any of the software or other underlying code
                        used to provide the Site; or
                      </li>
                      <li>
                        advocate, encourage, or assist any third party in doing
                        any of the foregoing.
                      </li>
                    </ul>
                    <h4>User Content</h4>
                    <p>
                      The Site may allow you to upload, submit, store, send, or
                      receive content and data such as comments, reviews and
                      photos ("User Content"). You may also submit User Content
                      in the other ways that you interact with Us such as
                      through social media, by email, by phone, and otherwise.
                      You retain ownership of any intellectual property rights
                      that you hold in that User Content.
                    </p>
                    <p>
                      When you upload, post, submit, send, or receive any User
                      Content to or through the Site, you give Us permission to
                      reproduce and use your User Content as follows: you grant
                      to Us and those we work with a license to use, host,
                      store, reproduce, modify, create derivative works (such as
                      translations, adaptations, or other changes we make so
                      that User Content works better with the Site), publicly
                      perform, publicly display, and distribute your User
                      Content. This license is for the purpose of operating and
                      improving the Site, to develop new products and services,
                      and for other Williams-Sonoma, Inc. marketing purposes,
                      including without limitation in catalogs, email and other
                      customer communications, store materials and other
                      marketing. We may display advertisements in connection
                      with your User Content or on pages where your User Content
                      may be viewed by you or others, and we may use your User
                      Content to advertise and promote Williams-Sonoma, Inc. or
                      the Site. Our license to your User Content is
                      non-exclusive, meaning you may use the User Content for
                      your own purposes or let others use your User Content for
                      their purposes. This license is fully-paid and royalty
                      free, meaning we do not owe you anything else in
                      connection with our use of your User Content. We may
                      exercise our rights under this license anywhere in the
                      world. Lastly, this license is perpetual, meaning that our
                      rights under this license continue even after you stop
                      using the Site.
                    </p>
                    <p>You promise that:</p>
                    <ul className="bulleted">
                      <li>
                        you own all rights to your User Content or,
                        alternatively, that you have the right to give us the
                        rights described above;
                      </li>
                      <li>
                        your User Content does not infringe the intellectual
                        property rights, privacy rights, publicity rights, or
                        other legal rights of any third party
                      </li>
                      <li>
                        we may refuse to accept or transmit User Content for any
                        reason with or without notice. We may remove User
                        Content from the Site for any reason with or without
                        notice.
                      </li>
                    </ul>
                    <p>
                      We may refuse to accept or transmit User Content for any
                      reason with or without notice. We may remove User Content
                      from the Site for any reason with or without notice.
                    </p>
                    <p>
                      <Link onClick={toTop} to="#top">
                        ▲ Back to Top
                      </Link>
                    </p>
                    <h4>Copyright Policy</h4>
                    <p>
                      We respond to notices of alleged copyright infringement
                      and terminate accounts of repeat infringers according to
                      the process set out in the U.S. Digital Millennium
                      Copyright Act. If you believe that a work on the Site
                      constitutes copyright infringement, please provide a
                      written communication with the following information to
                      Our Designated Agent named below:
                    </p>
                    <ul className="bulleted">
                      <li>
                        Your address, telephone number, and email address;
                      </li>
                      <li>
                        A description of the copyrighted work that you claim has
                        been infringed;
                      </li>
                      <li>
                        A description of where the alleged infringing material
                        is located on the Site including a hyperlink to such
                        location;
                      </li>
                      <li>
                        A statement by you that you have a good faith belief
                        that the disputed use is not authorized by you, the
                        copyright owner, its agent, or the law;
                      </li>
                      <li>
                        An electronic or physical signature of the person
                        authorized to act on behalf of the owner of the
                        copyright interest; and
                      </li>
                      <li>
                        A statement by you, made under penalty of perjury, that
                        the above information is accurate and that you are the
                        copyright owner or authorized to act on behalf of the
                        copyright owner.
                      </li>
                    </ul>
                    <p>
                      Our Designated Agent for notice of claims of copyright
                      infringement can be reached at:
                    </p>
                    <p>
                      Williams-Sonoma, Inc. Legal Department
                      <br /> 3250 Van Ness Avenue
                      <br /> San Francisco, CA 94109
                      <br />{" "}
                      <Link onClick={toTop} to="mailto:qty@retteve.store">
                        qty@retteve.store
                      </Link>
                    </p>
                    <p>
                      For clarity, only copyright infringement notices should go
                      to our Designated Agent. You acknowledge that if you fail
                      to comply with all of the requirements of this section,
                      your notice may not be valid.
                    </p>
                    <p>
                      If you believe the content that was removed (or to which
                      access was disabled) is not infringing, or that you have
                      the authorization from the copyright owner, the copyright
                      owner's agent, or pursuant to the law, to post and use
                      such content, you may submit a counter-notice to the
                      address listed above containing the following information:
                    </p>
                    <ul className="bulleted">
                      <li>Your physical or electronic signature;</li>
                      <li>
                        Identification of the content that has been removed or
                        to which access has been disabled and the location at
                        which the content appeared before it was removed or
                        disabled;
                      </li>
                      <li>
                        A statement that you have a good faith belief that the
                        content was removed or disabled as a result of mistake
                        or a misidentification of the content; and
                      </li>
                      <li>
                        Your name, physical address, telephone number, and
                        e-mail address, a statement that you consent to the
                        jurisdiction of the federal court in San Francisco,
                        California, and a statement that you will accept service
                        of process from the person who provided notification of
                        the alleged infringement.
                      </li>
                    </ul>
                    <p>
                      After We receive your counter-notification, We will
                      forward it to the party who submitted the original claim
                      of copyright infringement. Please note that when we
                      forward the counter-notification, it includes your
                      personal information. By submitting a
                      counter-notification, you consent to having your
                      information revealed in this way. We will not forward the
                      counter-notification to any party other than the original
                      claimant.
                    </p>
                    <p>
                      After We send out the counter-notification, the claimant
                      must then notify us within 10 days that he or she has
                      filed an action seeking a court order to restrain you from
                      engaging in infringing activity relating to the content
                      that was removed or disabled. If We receive such
                      notification We will be unable to restore the material. If
                      we do not receive such notification, we may reinstate the
                      material.
                    </p>
                    <h4>Open Source</h4>
                    <p>
                      The Site may include open source components, which are
                      licensed for use and distribution under applicable open
                      source licenses. Use of any open source components is
                      governed by and subject to the terms and conditions of the
                      applicable open source license.
                    </p>
                    <h4>Hyperlinks to other Sites</h4>
                    <p>
                      To the extent our Site contains hyperlinks to outside
                      services and resources, the availability and content of
                      which Williams-Sonoma, Inc. does not control, any concerns
                      regarding any such service or resource, or any hyperlink
                      thereto, should be directed to the particular outside
                      service or resource.
                    </p>
                    <p>
                      <Link onClick={toTop} to="#top">
                        ▲ Back to Top
                      </Link>
                    </p>
                    <h4>Disclaimer</h4>
                    <p>
                      THIS SITE AND ALL CONTENT AVAILABLE ON THE SITE ARE
                      PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT
                      WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED,
                      STATUTORY, OR OTHERWISE, INCLUDING WITHOUT LIMITATION
                      WARRANTIES OF TITLE OR IMPLIED WARRANTIES OF
                      MERCHANTABILITY, NON-INFRINGEMENT, OR FITNESS FOR A
                      PARTICULAR PURPOSE OR THOSE ARISING OUT OF A COURSE OF
                      DEALING OR USAGE OF TRADE, TO THE FULLEST EXTENT PERMITTED
                      BY APPLICABLE LAW. TO THE FULLEST EXTENT PERMITTED BY
                      APPLICABLE LAW, YOU ACKNOWLEDGE AND AGREE, BY YOUR USE OF
                      THIS SITE THAT YOUR USE IS AT YOUR SOLE RISK, THAT YOU
                      ASSUME FULL RESPONSIBILITY FOR ALL COSTS ASSOCIATED WITH
                      ALL NECESSARY SERVICING OR REPAIRS OF ANY EQUIPMENT YOU
                      USE IN CONNECTION WITH YOUR USE, AND THAT WILLIAMS-SONOMA,
                      INC. AND ITS OFFICERS, EMPLOYEES, DIRECTORS, SHAREHOLDERS,
                      PARENTS, SUBSIDIARIES, AFFILIATES, AGENTS, AND LICENSORS
                      ("AFFILIATES") SHALL NOT BE LIABLE FOR ANY DAMAGES OF ANY
                      KIND RELATED TO YOUR USE OF THIS SITE OR OUR MOBILE
                      APPLICATIONS.
                    </p>
                    <p>
                      IN PARTICULAR AND TO THE FULLEST EXTENT PERMITTED BY
                      APPLICABLE LAW, WILLIAMS-SONOMA, INC. AND ITS AFFILIATES
                      MAKE NO REPRESENTATIONS OR WARRANTIES ABOUT THE ACCURACY
                      OR COMPLETENESS OF CONTENT AVAILABLE ON OR THROUGH THE
                      SITE, OR THE CONTENT OF THE SITE OR ONLINE SERVICES LINKED
                      TO OR INTEGRATED WITH THE SITE. TO THE FULLEST EXTENT
                      PERMITTED BY APPLICABLE LAW, WILLIAMS-SONOMA, INC. AND ITS
                      AFFILIATES WILL HAVE NO LIABILITY FOR ANY: (a) ERRORS,
                      MISTAKES, OR INACCURACIES OF CONTENT; (b) PERSONAL INJURY
                      OR PROPERTY DAMAGE RESULTING FROM YOUR ACCESS TO OR USE OF
                      THE SITE; (c) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR
                      SERVERS OR OF ANY PERSONAL INFORMATION OR USER DATA; (d)
                      ANY INTERRUPTION OF TRANSMISSION TO OR FROM THE SITE; (e)
                      ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE
                      TRANSMITTED ON OR THROUGH THE SITE BY ANY THIRD PARTY; OR
                      (f) ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF
                      THE USE OF ANY CONTENT POSTED OR SHARED THROUGH THE SITE.
                    </p>
                    <p>
                      TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO
                      EVENT WILL WILLIAMS-SONOMA, INC. OR ITS AFFILIATES BE
                      LIABLE TO YOU OR ANY THIRD PARTY FOR ANY INDIRECT,
                      SPECIAL, INCIDENTAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES
                      (INCLUDING FOR THE INDIRECT LOSS OF PROFIT, REVENUE, OR
                      DATA) ARISING OUT OF OR RELATING TO THE SITE OR MOBILE
                      APPLICATIONS, HOWEVER CAUSED, AND UNDER WHATEVER CAUSE OF
                      ACTION OR THEORY OF LIABILITY BROUGHT (INCLUDING UNDER ANY
                      CONTRACT, NEGLIGENCE, OR OTHER TORT THEORY OF LIABILITY)
                      EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                    </p>
                    <p>
                      Some jurisdictions do not allow the exclusion of certain
                      warranties or the limitation or exclusion of liability for
                      damages. Accordingly, some of the above limitations and
                      disclaimers may not apply to you. To the extent we may
                      not, as a matter of applicable law, disclaim any warranty
                      or limit our liability, the scope and duration of such
                      warranty and the extent of our liability will be the
                      minimum permitted under such law.
                    </p>
                    <h4>Product Pricing Information</h4>
                    <p>
                      The prices displayed on our Site may differ from prices
                      that are available in stores or in catalogs, and our
                      pricing may differ from store to store. If you are in the
                      U.S. or Canada, Site prices will be displayed in U.S.
                      Dollars. Elsewhere, Site prices will generally be
                      displayed in the local currency. The prices displayed in
                      our printed catalogs are quoted in U.S. Dollars and are
                      valid and effective only in the U.S.
                    </p>
                    <p>
                      For full-price products, "Suggested Price" or "Sugg.
                      Price" refers to the manufacturers' suggested retail
                      price. "Our Price" refers to the everyday value price we
                      offer to our customers. For sale products (identified by
                      pricing in red), "Suggested Price" or "Sugg. Price" refers
                      to the most recent selling price. "Sale" refers to the
                      reduced price we are offering to our customers.
                    </p>
                    <h4>Special Offers</h4>
                    <p>
                      Occasionally We will offer special promotions to our
                      customers that We refer to as "special offers" or "special
                      offer". This can include a gift with purchase, free
                      shipping, manufacturer offers, or other promotional
                      activity associated with a product purchase. These offers
                      may be for a limited time only.&nbsp;In addition, products
                      marked as "exclusive" or "only at Williams Sonoma" may be
                      referring only to certain colors, sizes, finishes and/or
                      versions of a product.
                    </p>
                    <p>
                      During Free Shipping promotions, *some exclusions apply.
                      Free shipping offer applies to standard shipping only.
                      Offer not valid for rush shipping, international shipping,
                      flat rate delivery, doorstep delivery, white glove
                      delivery, or third-party shipping carriers . Free shipping
                      offer is not valid on select items shipped directly from
                      vendors. Offer cannot be applied to previous purchases or
                      combined with any other offer; additional exclusions may
                      apply. Offer subject to change at any time. US orders
                      only.
                    </p>
                    <p>
                      Free shipping offer valid when you enter code FREESHIP at
                      checkout. Offer excludes White Glove Delivery and doorstep
                      delivery services.
                    </p>
                    <h4>Text Message Program Terms</h4>
                    <p>
                      Williams-Sonoma, Inc. offers its customers mobile alerts
                      about order and shipping updates and other marketing
                      messages about events, new products, and other offers by
                      SMS message (the "Service"). By participating in the
                      Service, you are agreeing to these Terms and to the{" "}
                      <Link onClick={toTop} to="/privacy">
                        Privacy Policy
                      </Link>
                      .
                    </p>
                    <p>Signing Up and Opting-In to the Service</p>
                    <p>
                      Enrollment in the Service requires you to provide your
                      mobile phone number and to agree to these terms and
                      conditions. You may not enroll if you are under 18 years
                      old (except in Alabama and Nebraska, 19 years old). Before
                      the Service will start, you will need to verify the mobile
                      phone number you provided by responding to a text message
                      to your mobile phone that affirms your choice to opt-in to
                      this Service and your agreement to these Terms.
                      Williams-Sonoma, Inc. reserves the right to stop offering
                      the Service at any time with or without notice.
                    </p>
                    <p>By opting into the Service, you:</p>
                    <ul>
                      <li>
                        authorize Williams Sonoma Inc. to use autodialer or
                        non-autodialer technology to send text messages to the
                        mobile phone number associated with your opt-in (i.e.,
                        the number listed on the opt-in form or, if none, the
                        number from which you send the opt-in, or, if none, the
                        number on file for the account associated with your
                        opt-in).
                      </li>
                      <li>
                        acknowledge that you do not have to agree to receive
                        messages as a condition of purchase.
                      </li>
                      <li>
                        confirm that you are the subscriber to the relevant
                        phone number or that you are the customary user of that
                        number on a family or business plan and that you are
                        authorized to opt in.
                      </li>
                      <li>
                        consent to the use of an electronic record to document
                        your opt-in. To request a free paper or email copy of
                        the opt-in or to update our records with your contact
                        information, please call 1.888.401.1900. To view and
                        retain an electronic copy of these Terms or the rest of
                        your opt-in, you will need (i) a device (such as a
                        computer or mobile phone) with Internet access, and (ii)
                        and either a printer or storage space on such device.
                        For an email copy, you'll also need an email account you
                        can access from the device, along with a browser or
                        other software that can display the emails.
                      </li>
                    </ul>
                    <p>Messages You May Receive</p>
                    <p>
                      Once you affirm your choice to opt into the Service, your
                      message frequency may vary. You may receive an alert when:
                    </p>
                    <ul>
                      <li>you are welcomed into the Service</li>
                      <li>an order has been placed</li>
                      <li>an order has been delivered</li>
                      <li>
                        an item or items has shipped; an item or items are ready
                        for an in-store pick up
                      </li>
                      <li>there are general marketing or promotions</li>
                    </ul>
                    <p>Charges and Carriers</p>
                    <p>
                      Message and data rates may apply. Please consult your
                      service agreement with your wireless carrier or contact
                      your wireless carrier to determine your phone's pricing
                      plan and the charges for sending and receiving text
                      messages. You acknowledge that you are responsible for any
                      message, data or other charges incurred (usage,
                      subscription, etc.) as a result of using the Service.
                    </p>
                    <p>
                      Supported carriers are AT &amp; T, T-Mobile, Verizon
                      Wireless, Sprint, Boost, Virgin Mobile, U.S. Cellular,
                      Cricket, Alltel, Cincinnati Bell, Cellcom, C-Spire,
                      nTelos, MetroPCS, and other smaller regional carriers. The
                      Service may not be available on all wireless carriers.
                      Williams-Sonoma, Inc. may add or remove any wireless
                      carrier from the Service at any time without notice.
                      Williams-Sonoma, Inc. and mobile carriers are not
                      responsible for any undue delays, failure of delivery, or
                      errors in messages.
                    </p>
                    <p>To Stop the Service</p>
                    <p>
                      To stop receiving text messages from Williams-Sonoma,
                      Inc., text the word STOP to 94925 any time or reply STOP
                      to any of the text messages you have received from
                      Williams-Sonoma, Inc. For Services operated through a
                      different number, text STOP to that number to opt out.
                      Your opt-out request may generate either a confirmation
                      text or a texted request to clarify the text message
                      program to which it applies (if you have more than one).
                      To complete your opt-out, please provide the requested
                      clarification. You acknowledge that the text message
                      platform may not recognize and respond to unsubscribe
                      requests that do not include the STOP keyword command and
                      agree that Williams-Sonoma, Inc. and its service providers
                      will have no liability for failing to honor such
                      requests.&nbsp;If you wish to opt out via US mail, please
                      send your opt out request to Williams-Sonoma, Inc. c/o
                      Corporation Service Company, 251 Little Falls Drive,
                      Wilmington, DE. Please be sure to specify the text message
                      program that you wish to opt out from in your request.
                      &nbsp;If you unsubscribe from one of our text message
                      programs, you may continue to receive text messages from
                      Williams-Sonoma, Inc. through any other programs you have
                      joined until you separately unsubscribe from those
                      programs. These Terms still will apply if you withdraw the
                      consent mentioned above or opt out of the Service.
                    </p>
                    <p>Questions</p>
                    <p>
                      You can text HELP for help at any time. This will provide
                      you a link to the terms and conditions along with a phone
                      number to call for assistance. You can also contact us at
                      1.888.401.1900.
                    </p>
                    <p>Mobile Phone Number Change</p>
                    <p>
                      In the event that you change or deactivate your mobile
                      phone number, you agree to notify Williams-Sonoma, Inc. by
                      calling 1.888.401.1900.
                    </p>
                    <h4>Inaccuracy Disclaimer</h4>
                    <p>
                      From time to time there may be information on our Site or
                      in our catalog that contains typographical errors,
                      inaccuracies, or omissions that may relate to product
                      descriptions, pricing, and availability. Williams-Sonoma,
                      Inc. reserves the right to correct any errors,
                      inaccuracies or omissions and to change or update
                      information at any time without prior notice (including
                      after you have submitted your order). If you do not wish
                      to continue your purchase after pricing or other
                      information has been corrected, please contact us right
                      away and we will work with you to cancel or return your
                      order.
                    </p>
                    <h4>Browsing Session Information</h4>
                    <p>
                      We use technologies that maintain records of your browsing
                      session, chats, and other activities on our Site. These
                      technologies may include session replay that maintains a
                      record of your interactions with our Site, chat providers
                      that maintain a transcript of your chats, cookies, pixels,
                      and other tracking technologies that share some of your
                      interactions with our Site, as well as other technologies
                      that collect and share your interactions with our Site. We
                      use this information for quality control, customer
                      service, fraud prevention and security, and marketing
                      purposes and in accordance with our{" "}
                      <Link onClick={toTop} to="/privacy">
                        Privacy Policy
                      </Link>
                      .
                    </p>
                    <h4>Indemnification</h4>
                    <p>
                      To the fullest extent permitted by applicable law, you
                      agree to indemnify and hold harmless Williams-Sonoma, Inc.
                      and its Affiliates from and against any and all claims,
                      costs, proceedings, demands, losses, damages, and expenses
                      (including, without limitation, reasonable attorney's fees
                      and legal costs) of any kind or nature, arising from or
                      relating to, any actual or alleged breach of these Terms
                      by you or anyone using your account. If we assume the
                      defense of such a matter, you will reasonably cooperate
                      with us in such defense.
                    </p>
                    <p>
                      <Link onClick={toTop} to="#top">
                        ▲ Back to Top
                      </Link>
                    </p>
                    <h4>Informal Dispute Resolution</h4>
                    <p>
                      We try to address any disputes without the need to
                      initiate a formal legal case. You agree that prior to
                      submitting any dispute or claim to arbitration for
                      resolution, you and we agree to make a good faith effort
                      to resolve it informally, including having at least one
                      telephone or videoconference conversation between you,
                      personally, and us. To initiate this good faith effort to
                      informally resolve a dispute you agree to notify us in
                      writing at Williams-Sonoma, Inc. c/o Corporation Service
                      Company, 251 Little Falls Drive, Wilmington, DE 19808. of
                      the nature of the dispute, the basis for your claims and
                      the resolution that you are seeking, including any
                      monetary amount, with as much detail as you can provide so
                      that we can gain a sufficient understanding of the
                      dispute. Within the sixty (60) days following our receipt
                      of this notice, you agree to engage in good faith efforts
                      to resolve the dispute, including personally participating
                      in a telephone call or videoconference with us. You may
                      have a lawyer attend the call with you if you wish. If the
                      dispute is not resolved within that sixty(60) days (which
                      period can be extended by agreement of the parties), you
                      or we may commence an arbitration to resolve the dispute
                      consistent with the process set forth below. Compliance
                      with and completing this informal dispute resolution
                      process is a condition precedent to commencing an
                      arbitration. You and we agree to toll any applicable
                      statute of limitations and filing fee deadlines while the
                      parties engage in this informal dispute resolution process
                      from the date we receive your notice. A court of competent
                      jurisdiction shall have the authority to enforce this
                      condition precedent to arbitration, which includes the
                      power to enjoin the filing or prosecution of a demand for
                      arbitration.
                    </p>
                    <h4 id="arbitration">
                      Arbitration Agreement &amp; Waiver of Certain Rights
                    </h4>
                    <p>
                      You and Williams-Sonoma, Inc. agree that, except as set
                      forth below, we will resolve any controversies, claims,
                      counterclaims, or other disputes between you and
                      Williams-Sonoma, Inc. or you and a third-party agent of
                      Williams-Sonoma, Inc. (a "Claim") through final and
                      binding arbitration instead of through court proceedings,
                      in accordance with the Consumer Arbitration Rules of the
                      American Arbitration Association ("AAA Rules"). This
                      arbitration agreement applies to any existing or future
                      Claims that you have not individually filed in a court of
                      law or in arbitration prior to the date you agreed to
                      these Terms. The AAA Rules are available at www.adr.org or
                      by calling 1-800-778-7879. You and we hereby waive any
                      right to a jury trial of any Claim. The arbitration will
                      be heard and determined by a single arbitrator. The
                      arbitrator's decision in any such arbitration will be
                      final and binding upon the parties and may be enforced in
                      any court of competent jurisdiction. The parties agree
                      that the arbitration proceedings will be kept confidential
                      and that the existence of the proceeding and any element
                      of it (including, without limitation, any pleadings,
                      briefs or other documents submitted or exchanged and any
                      testimony or other oral submissions and awards) will not
                      be disclosed beyond the arbitration proceedings, except as
                      may lawfully be required in judicial proceedings relating
                      to the arbitration, by applicable disclosure rules and
                      regulations of securities regulatory authorities or other
                      governmental agencies, or as specifically permitted by
                      state law. The Federal Arbitration Act and federal
                      arbitration law apply to this agreement.&nbsp;A court of
                      competent jurisdiction will exclusively determine whether
                      the parties have entered into a valid and enforceable
                      agreement to arbitrate their Claims and the arbitrability
                      of any Claim or counterclaim, including, without
                      limitation, whether any conditions precedent to the
                      commencement of an arbitration have been completely
                      satisfied.
                    </p>
                    <p>
                      To begin an arbitration proceeding, you must send us an
                      individual letter signed by you requesting arbitration and
                      describing your claim at Williams-Sonoma, Inc. c/o
                      Corporation Service Company, 251 Little Falls Drive,
                      Wilmington, DE 19808. This letter must be sent at least
                      five (5) days before you initiate an arbitration
                      proceeding against us.
                    </p>
                    <p>
                      Any party to the arbitration, at any time more than ten
                      (10) days before the arbitration hearing, may serve an
                      offer of compromise in writing upon any other party to the
                      action. Offers of compromise pursuant to these Terms will
                      be adjudicated and interpreted in accordance with
                      California Code of Civil Procedure section 998.
                    </p>
                    <p>
                      If you demonstrate that the costs of arbitration will be
                      prohibitive as compared to the costs of litigation,
                      Williams-Sonoma, Inc. will pay as much of the
                      administrative costs and arbitrator's fees required for
                      the arbitration as the arbitrator deems necessary to
                      prevent the cost of the arbitration from being
                      prohibitive. In the final award, the arbitrator may
                      apportion the costs of arbitration and the compensation of
                      the arbitrator among the parties in such amounts as the
                      arbitrator deems appropriate. In the final award, the
                      arbitrator may apportion the costs of arbitration and the
                      compensation of the arbitrator among the parties in such
                      amounts as the arbitrator deems appropriate.
                    </p>
                    <p>
                      This arbitration agreement does not preclude you or
                      Williams-Sonoma, Inc. from seeking action by federal,
                      state, or local government agencies. You and
                      Williams-Sonoma, Inc. also have the right to bring
                      qualifying claims in small claims court or transfer
                      qualifying claims to small claims court. Either party may
                      elect that a Claim be filed exclusively in a small claims
                      court of competent jurisdiction by providing notice to the
                      other party. In the Event a Claim has already been filed
                      in arbitration, the party who has filed that claim will,
                      within ten (10) days of receiving such a notice, withdraw
                      their Claim from arbitration. The parties will then
                      proceed with the Claim exclusively in small claims court.
                      A party may apply to any court of competent jurisdiction
                      to enforce the terms of this paragraph. In addition, you
                      and Williams-Sonoma, Inc. retain the right to apply to any
                      court of competent jurisdiction for provisional relief,
                      including pre-arbitral attachments or preliminary
                      injunctions. Any such request shall not be deemed
                      incompatible with these Terms and Conditions, nor a waiver
                      of the right to have disputes submitted to arbitration as
                      provided in these Terms and Conditions.
                    </p>
                    <p>
                      Neither you nor Williams-Sonoma, Inc. may act as a class
                      representative or private attorney general, nor
                      participate as a member of a class of claimants, with
                      respect to any Claim. You may not bring Claims in
                      arbitration on a class or representative basis. The
                      arbitrator can decide only your and/or Williams-Sonoma,
                      Inc.'s individual Claims.
                    </p>
                    <p>
                      If for any reason a claim proceeds in court rather than in
                      arbitration you and Williams-Sonoma, Inc. each waive any
                      right to a jury trial. No waiver of any provision of this
                      Section of the Terms and Conditions will be effective or
                      enforceable unless recorded in a writing signed by the
                      party waiving such a right or requirement. Such a waiver
                      shall not waive or affect any other portion of these Terms
                      and Conditions. The arbitrator may award in the
                      arbitration the same damages or other relief available
                      under applicable law, including injunctive and declaratory
                      relief, as if the action were brought in court on an
                      individual basis. Notwithstanding anything to the contrary
                      in the foregoing or herein, the arbitrator may not issue a
                      "public injunction" and any such "public injunction" may
                      be awarded only by a federal or state court. If either
                      party seeks a "public injunction," all other claims and
                      prayers for relief must be adjudicated in arbitration
                      first and any prayer or claim for a "public injunction" in
                      federal or state court stayed until the arbitration is
                      completed, after which the federal or state court can
                      adjudicate the party's claim or prayer for "public
                      injunctive relief." In doing so, the federal or state
                      court is bound under principles of claim or issue
                      preclusion by the decision of the arbitrator. This
                      Arbitration Agreement &amp; Waiver of Certain Rights
                      Section of the Terms and Conditions will survive the
                      termination of your relationship with Williams-Sonoma,
                      Inc.
                    </p>
                    <p>
                      THIS SECTION LIMITS CERTAIN RIGHTS, INCLUDING THE RIGHT TO
                      MAINTAIN A COURT ACTION, THE RIGHT TO A JURY TRIAL, THE
                      RIGHT TO PARTICIPATE IN ANY FORM OF CLASS OR
                      REPRESENTATIVE CLAIM, THE RIGHT TO ENGAGE IN DISCOVERY
                      EXCEPT AS PROVIDED IN AAA RULES, AND THE RIGHT TO CERTAIN
                      REMEDIES AND FORMS OF RELIEF. OTHER RIGHTS THAT YOU OR
                      WILLIAMS-SONOMA, INC. WOULD HAVE IN COURT ALSO MAY NOT BE
                      AVAILABLE IN ARBITRATION.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <b>Mass Arbitration Process Requirements</b>
                    </p>
                    <p>
                      If twenty-five (25) or more similar claims are asserted
                      against Williams-Sonoma, Inc. at or around the same time
                      by the same or coordinated counsel or are otherwise
                      coordinated (and your claim is one such claim), you
                      understand and agree that the resolution of your claim
                      might be delayed. You also agree to the following process
                      and application of the AAA Multiple Consumer Case Filing
                      Fee Schedule and Supplementary Rules. Regardless of the
                      provisions in the arbitration agreement above about the
                      prohibitive costs of individual arbitration for you, if
                      your lawyer or their business partner (each a “Third Party
                      Funder”) is directly or indirectly paying or advancing the
                      arbitration fees and costs in a mass arbitration on your
                      behalf, the Process Arbitrator shall have discretion to
                      determine whether the total arbitration fees and costs due
                      to AAA should be split evenly between the Third Party
                      Funder(s), on the one hand, and us, on the other hand. The
                      Process Arbitrator shall make or confirm this
                      discretionary decision before the initiation of each
                      batch, as set out below. In the final decision, the
                      arbitrator can reevaluate and divide the arbitration fees
                      and costs among the Third Party Funder(s) and us in
                      amounts they see fit to ensure a fair division among the
                      parties. Additionally, when permitted under applicable
                      rules, you may be responsible for our arbitration fees and
                      costs.Twenty (20) claims shall be selected to proceed to
                      individual arbitration proceedings as part of a first
                      batching process, ten (10) of which will be selected by
                      the claimants and ten (10) of which will be selected by
                      Williams-Sonoma, Inc. The remaining claims shall not be
                      filed or deemed filed in arbitration nor shall any AAA
                      fees be assessed in connection with those claims until
                      they are selected to proceed to individual arbitration
                      proceedings as part of the staged process described
                      herein. If the parties are unable to resolve the remaining
                      claims after the conclusion of the initial twenty (20)
                      proceedings, the parties shall participate in a global
                      mediation session before a retired state or federal court
                      judge, for which Williams-Sonoma, Inc. will pay the
                      mediator's fee. If the parties are unable to resolve the
                      remaining claims through mediation at this time, then
                      forty (40) claims shall be selected to proceed to
                      individual arbitration proceedings as part of a second
                      batching process, twenty (20) of which will be selected by
                      the claimants and twenty (20) of which will be selected by
                      Williams-Sonoma, Inc. (If there are fewer than forty (40)
                      claims remaining, all shall proceed.) The remaining claims
                      shall not be filed or deemed filed in arbitration nor
                      shall any AAA fees be assessed in connection with those
                      claims until they are selected to proceed to individual
                      arbitration proceedings as part of the staged process
                      described herein. In any batching process, a single
                      arbitrator shall preside over each proceeding, and only
                      one proceeding may be assigned to each arbitrator unless
                      the parties agree otherwise. If the parties are unable to
                      resolve the remaining claims after the conclusion of the
                      forty (40) proceedings, the parties shall participate in
                      another global mediation session before a retired state or
                      federal court judge, for which Williams-Sonoma, Inc. will
                      pay the mediator's fee. If the parties are unable to
                      resolve the remaining claims in mediation at this time,
                      this staged process shall continue with no more than one
                      hundred (100) claims proceeding at any time in a staged
                      order that is selected randomly or by the AAA, until all
                      the coordinated claims, including your Claim, are
                      adjudicated or otherwise resolved. At any time during
                      these proceedings, we agree to participate in a global
                      mediation session should your counsel request it in an
                      effort to resolve all remaining claims. Any applicable
                      statute of limitations on your Claims and filing fee
                      deadlines shall be tolled for claims subject to this
                      section regarding “Mass Arbitration Process Requirements”
                      from the time claims are selected for the first set of
                      batching proceedings until the time your Claim is selected
                      to proceed in arbitration, withdrawn, or otherwise
                      resolved. A court of competent jurisdiction shall have
                      authority to enforce this section regarding “Mass
                      Arbitration Process Requirements” and, if necessary, to
                      enjoin the filing or prosecution of arbitration demands
                      against Williams-Sonoma, Inc. Should a court of competent
                      jurisdiction decline to enforce these "Mass Arbitration
                      Process Requirements," you and we agree that your and our
                      counsel shall engage in good faith and with the assistance
                      of a Process Arbitrator to devise and implement procedures
                      that ensure that arbitration remains efficient and
                      cost-effective for all parties. Either party may engage
                      with the AAA to address reductions in arbitration fees.
                    </p>
                    <h4>Other Provisions</h4>
                    <p>
                      To the extent any action relating to the use of the Site,
                      mobile applications, catalogs or any transaction with
                      Williams-Sonoma, Inc. is not required to be arbitrated or
                      filed in small claims court in accordance with the
                      Arbitration Agreement, such action must be brought in the
                      state or federal courts located in the County of San
                      Francisco, California. You consent and submit to the
                      personal jurisdiction of such courts for the purposes of
                      any such action.
                    </p>
                    <p>
                      Except as otherwise described in these Terms, these Terms
                      and Conditions will be governed by and construed in
                      accordance with the laws of the State of California,
                      without giving effect to any conflict of laws rules or
                      provisions.
                    </p>
                    <p>
                      Under no circumstances will we be held liable for any
                      delay or failure in performance due in whole or in part to
                      any acts of nature or other causes beyond our reasonable
                      control.
                    </p>
                    <p>
                      Except for the Mass Arbitration Process Requirements
                      section, if any of the terms or conditions herein shall be
                      deemed unlawful or unenforceable, that term or condition
                      shall be deemed severable and shall not affect the
                      validity and enforceability of any remaining term or
                      condition. However, if a Claim is part of a Mass
                      Arbitration, and any part of the Mass Arbitration Process
                      Requirements section is found to be invalid, void, or
                      unenforceable, the Arbitration Agreement &amp; Waiver of
                      Certain Rights, including the Mass Arbitration Process
                      Requirements section, shall be severed in its entirety.
                    </p>
                    <p>
                      The failure by us to enforce any right or provision of
                      these Terms will not prevent us from enforcing such right
                      or provision in the future.
                    </p>
                    <p>
                      We may assign our rights and obligations under these
                      Terms, including in connection with a merger, acquisition,
                      sale of assets or equity, or by operation of law.
                    </p>
                    <h4>Accessibility</h4>
                    <p>
                      We strive to make our Site content accessible and
                      user-friendly. If you are having difficulty viewing the
                      content on this Site or navigating the site, please call
                      our Customer Service Team toll-free at 1.888.401.1900 and
                      we will be happy to assist you.
                    </p>
                    <p>
                      <Link onClick={toTop} to="#top">
                        ▲ Back to Top
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              {/**/}
            </div>
          </div>
          <div className="mobileContentWrapper" style={{ display: "none" }}>
            <div>
              <div
                className="ecm-content-wrapper"
                data-style="ecm-content-wrapper"
              />
            </div>
          </div>
          <div className="ecm-content-script-container" />
          <div className="ecm-content-style-container" />
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Terms;
